import React from "react";
import DatePicker from "../../../../components/DatePicker";
import { getAttendanceMaxDate } from "../../utils/dateUtils";

/**
 * Attendance-specific DatePicker wrapper.
 * Delegates to the shared DatePicker component.
 *
 * Normally capped at today: attendance for a day after the current day cannot
 * be viewed or processed, and the backend rejects such requests with 400
 * (code "FUTURE_DATE_NOT_ALLOWED").
 *
 * getAttendanceMaxDate() returns undefined while the ALLOW_FUTURE_DATES
 * testing flag is on (see utils/dateUtils.js), which removes the cap so the
 * backend guard can be exercised from the UI.
 */
const AttendanceDatePicker = ({ theme, isRTL, t, selectedDate, setSelectedDate }) => {
  return (
    <DatePicker
      theme={theme}
      isRTL={isRTL}
      label={t.selectDate}
      value={selectedDate}
      onChange={setSelectedDate}
      maxDate={getAttendanceMaxDate()}
      dropDirection="down"
    />
  );
};

export default AttendanceDatePicker;